import { VoidFunctionComponent } from 'react';
import map from './Icon.map';
import { StyledIcon } from './Icon.styled';
import { IconProps } from './types';

export const Icon: VoidFunctionComponent<IconProps> = props => {
  const { name, ...rest } = props;

  // Ensure the specified icon exists in the map
  const Component = map[name];
  if (!Component) {
    return null;
  }

  return (
    <StyledIcon {...rest}>
      <Component />
    </StyledIcon>
  );
};
